function setLayoutHeights() {
  const bar = document.querySelector("announcement-bar");
  const header = document.querySelector("header");

  let announcementHeight = 0;
  let headerHeight = 0;

  if (bar) announcementHeight = bar.getBoundingClientRect().height;
  if (header) headerHeight = header.getBoundingClientRect().height;

  const root = document.documentElement;

  root.style.setProperty("--announcement-height", `${announcementHeight}px`);
  root.style.setProperty("--header-height", `${headerHeight}px`);
}

// FAST execution → as soon as DOM is ready
document.addEventListener("DOMContentLoaded", setLayoutHeights);

// Backup → ensure correct after everything loads
window.addEventListener("load", setLayoutHeights);

// Responsive recalculation
window.addEventListener("resize", setLayoutHeights);
